import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './AuditlogsActionType';
import * as actions from './AuditlogsAction';
import * as services from './Auditlogsservices';
import { downloadBase64File } from "../../../../utils/fileDownloads";
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

function* fetchRadiologistAllDDListSaga() {
    try {
        const response = yield call(services.fetchRadiologistAllDDList);
        if (response?.success) {
            yield put(actions.fetchRadiologistAllDDListSuccess(response.values));
        } else {
            yield put(actions.fetchRadiologistAllDDListFailure('No data found'));
        }
    } catch (error) {
        yield put(actions.fetchRadiologistAllDDListFailure('Failed to fetch Provider All DD List'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Provider All DD List' });
    }
}

function* exportAuditlogdetails(action) {
    try {
        const payload = action.payload;
        const response = yield call(services.exportAuditLogs, payload);
        const base64Data = response?.values || response;
        // Use fileName from payload if present, else fallback
        const fileName = payload.fileName || 'AuditLogs.csv';
        yield call(downloadBase64File, base64Data, 'AuditLogs', fileName);
    } catch (error) {
        console.error("Export error:", error);
        yield put(actions.exportAuditLogsFailure("Export failed"));
    }
}

function* fetchGetAllModuleFieldActionTypeDropdownSaga() {
    try {
        const response = yield call(services.fetchGetAllModuleFieldActionTypeDropdown);
        if (response?.success) {
            yield put(actions.fetchGetAllModuleFieldActionTypeDropdownSuccess(response.values));
        } else {
            yield put(actions.fetchGetAllModuleFieldActionTypeDropdownFailure('No data found'));
        }
    } catch (error) {
        yield put(actions.fetchGetAllModuleFieldActionTypeDropdownFailure('Failed to fetch Module Field Action Type Dropdown'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Module Field Action Type Dropdown' });
    }
}

function* fetchALLAuditLogsSaga(action) {
    try {
        const response = yield call(services.exportGetAllAuditLogs, action.payload);
        if (response?.success) {
            yield put(actions.exportAuditLogsAllListSuccess(response.values));
        } else {
            yield put(actions.exportAuditLogsAllListFailure('No data found'));
        }
    } catch (error) {
        console.error("Audit Logs Fetch Error:", error);
        yield put(actions.exportAuditLogsAllListFailure('Failed to fetch Audit Logs'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Audit Logs' });
    }
}

function* fetchALLAuditLogscustomreportSaga(action) {
    try {
        const response = yield call(services.GetAllAuditLogscustomreport, action.payload);
        if (response?.success) {
            yield put(actions.GetAuditLogscustomReportSuccess(
                Array.isArray(response.values) ? response.values : [response.values]
            ));
        }
        else {
            yield put(actions.GetAuditLogscustomReportFailure('No data found'));
        }
    } catch (error) {
        console.error("Audit Logs Fetch Error:", error);
        yield put(actions.GetAuditLogscustomReportFailure('Failed to fetch Audit Logs'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Audit Logs' });
    }
}

function* exportAuditlogcustomreport(action) {
    try {
        const payload = action.payload;
        const response = yield call(services.exportAuditLogscustomreport, payload);
        const base64Data = response?.values || response;
           // Use fileName from payload if present, else fallback
        const fileName = payload.fileName || 'AuditLogs.csv';
        yield call(downloadBase64File, base64Data, 'AuditLogCustomReport_Asof', fileName);
    } catch (error) {
        console.error("Export error:", error);
        yield put(actions.exportAuditLogscustomFailure("Export failed"));
    }
}

export default function* AuditlogsSaga() {
    yield takeEvery(types.FETCH_RADIOLOGIST_ALL_DDLIST_REQUEST, fetchRadiologistAllDDListSaga);
    yield takeEvery(types.EXPORT_AUDIT_LOGS_REQUEST, exportAuditlogdetails);
    yield takeEvery(types.GetAllModuleFieldActionTypeDropdown_REQUEST, fetchGetAllModuleFieldActionTypeDropdownSaga);
    yield takeEvery(types.GetAllAuditLogsList_REQUEST, fetchALLAuditLogsSaga);
    yield takeEvery(types.GETALLAUDITLOGCUSTOMREPORT_REQUEST, fetchALLAuditLogscustomreportSaga);
    yield takeEvery(types.EXPORTAUDITLOGCUSTOMREPORT_REQUEST, exportAuditlogcustomreport);
}